"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterOrigination = exports.currentYear = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var currentYear = function () {
    var d = new Date();
    return d.getFullYear();
};
exports.currentYear = currentYear;
var defaultFooterText = (React.createElement("p", null,
    "\u00A9 ",
    (0, exports.currentYear)(),
    " Commonwealth Bank of Australia ABN 48 123 123 124 AFSL and Australian credit licence 234945"));
var FooterOrigination = function (props) {
    return (React.createElement("div", { className: "footerorigination bg-light" },
        React.createElement("div", { className: props.fluid ? 'container-fluid' : 'container' },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("footer", { role: "contentinfo", className: "gutter-px pt-3" }, props.children || defaultFooterText))))));
};
exports.FooterOrigination = FooterOrigination;
exports.FooterOrigination.defaultProps = {
    fluid: true,
};
exports.FooterOrigination.propTypes = {
    children: PropTypes.element,
    fluid: PropTypes.bool,
};
